module.exports = {
  not_assessed: {
    value: -3,
    name: 'not_assessed',
  },
  inconclusive: {
    value: -2,
    name: 'inconclusive',
  },
  possible: {
    value: -1,
    name: 'possible',
  },
  risk_none: {
    value: 0,
    name: 'risk_none',
  },
  risk_present: {
    value: 1,
    name: 'risk_present',
  },
  risk_mild: {
    value: 2,
    name: 'risk_mild',
  },
  risk_moderate: {
    value: 3,
    name: 'risk_moderate',
  },
  risk_severe: {
    value: 4,
    name: 'risk_severe',
  },
};
